import { Button } from 'ui/button';
import { BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button/constants';
import { ModalFooter, ModalBody, ModalHeader, Modal, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { useModalContext } from 'utils/contexts/modal';
import { TEST_IDS, MODAL_HEADER_TEXT, getModalBodyText, MODAL_FOOTER_TEXT } from './constants';

export type UnsavedChangesModalProps = {
  isLoading?: boolean;
  isDisabled: boolean;
  modalId: string;
  onClose: () => void;
  onConfirm: () => void;
  resourceName: string;
};

export const UnsavedChangesModal = ({
  isDisabled,
  isLoading = false,
  modalId,
  onClose,
  onConfirm,
  resourceName,
}: UnsavedChangesModalProps) => {
  const { modalState } = useModalContext();
  if (modalState !== modalId) return null;
  return (
    <Modal
      withPortal
      onClose={onClose}
      isModalOpen={true}
      id={TEST_IDS.AI_UNSAVED_CHANGES_MODAL_TEST_ID}
      data-test={TEST_IDS.AI_UNSAVED_CHANGES_MODAL_TEST_ID}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader autoFocus={false}>{MODAL_HEADER_TEXT}</ModalHeader>
      <ModalBody>{getModalBodyText(resourceName)}</ModalBody>
      <ModalFooter>
        <Button
          isDisabled={isDisabled}
          isLoading={isLoading}
          data-test={TEST_IDS.AI_UNSAVED_CHANGES_MODAL_SAVE_BUTTON}
          onClick={onConfirm}
          size={BUTTON_SIZES.LARGE}
          variant={BUTTON_VARIANTS.DESTRUCTIVE}
        >
          {MODAL_FOOTER_TEXT}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
